/* ============================================================
   Polaris Recovery – Landingpage
   - Sticky-Header-Hoehe messen und als --polaris-offset setzen
   - Scroll-Spy: markiert links/oben den Bereich, in dem man gerade ist
   - Sanftes Springen beim Klick, ohne Neuladen, mit Hash in der URL
   ============================================================ */
(function () {
  'use strict';

  var instances = [];

  // Das Theme heftet die Kopfzeile erst beim Scrollen per JS an
  // (.site-header--stuck, position:fixed). Beim Laden ist sie noch statisch –
  // deshalb darf die Messung nicht davon abhaengen, ob sie gerade fixiert ist.
  // Wir reservieren immer ihre Hoehe: etwas zu viel Abstand faellt kaum auf,
  // zu wenig schneidet die Ueberschrift ab.
  function headerOffset() {
    var stuck = document.querySelector('.site-header--stuck');
    if (stuck) {
      var stuckHeight = stuck.getBoundingClientRect().height;
      if (stuckHeight) return stuckHeight;
    }
    var header = document.querySelector('.site-header');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function Polaris(root) {
    this.root = root;
    this.sections = Array.prototype.slice.call(root.querySelectorAll('[data-polaris-section]'));
    this.links = Array.prototype.slice.call(root.querySelectorAll('[data-polaris-jump]'));
    this.scroller = root.querySelector('.polaris__chips-scroller');
    this.offset = -1;
    this.ticking = false;
    this.activeId = null;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.measure();
    this.bind();
    this.update();
    this.jumpToInitialHash();
  }

  Polaris.prototype.measure = function () {
    var next = headerOffset();
    if (Math.abs(next - this.offset) < 2) return;
    this.offset = next;
    this.root.style.setProperty('--polaris-offset', Math.round(next) + 'px');
  };

  Polaris.prototype.bind = function () {
    var self = this;

    this.links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('data-polaris-jump');
        var target = id && document.getElementById(id);
        if (!target) return; // externer Link: normal folgen lassen
        event.preventDefault();
        self.scrollTo(target);
        if (history.pushState) history.pushState(null, '', '#' + id);
        self.setActive(id);
      });
    });

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
  };

  Polaris.prototype.destroy = function () {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  };

  Polaris.prototype.scrollTo = function (target) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - this.offset - 24;
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({ top: top, behavior: 'smooth' });
    } else {
      window.scrollTo(0, top);
    }
  };

  Polaris.prototype.jumpToInitialHash = function () {
    var hash = window.location.hash.replace('#', '');
    if (!hash) return;
    var target = document.getElementById(hash);
    if (!target || !this.root.contains(target)) return;
    var self = this;
    // Bilder/Sticky-Header sind beim Laden noch nicht final vermessen
    window.setTimeout(function () {
      self.measure();
      self.scrollTo(target);
      self.setActive(hash);
    }, 250);
  };

  Polaris.prototype.onScroll = function () {
    var self = this;
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(function () {
      self.measure();
      self.update();
      self.ticking = false;
    });
  };

  Polaris.prototype.onResize = function () {
    this.measure();
    this.update();
  };

  Polaris.prototype.update = function () {
    if (!this.sections.length) return;

    var line = this.offset + 32;
    var current = this.sections[0];

    for (var i = 0; i < this.sections.length; i++) {
      if (this.sections[i].getBoundingClientRect().top <= line) current = this.sections[i];
    }

    // Ganz unten angekommen: letzten Bereich markieren
    if (window.innerHeight + window.pageYOffset >= document.body.scrollHeight - 4) {
      current = this.sections[this.sections.length - 1];
    }

    this.setActive(current.id);
  };

  Polaris.prototype.setActive = function (id) {
    if (id === this.activeId) return;
    this.activeId = id;

    this.links.forEach(function (link) {
      var isActive = link.getAttribute('data-polaris-jump') === id;
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    this.centerChip(id);
  };

  Polaris.prototype.centerChip = function (id) {
    if (!this.scroller) return;
    var chip = this.scroller.querySelector('[data-polaris-jump="' + id + '"]');
    if (!chip) return;
    var left = chip.offsetLeft - (this.scroller.clientWidth - chip.offsetWidth) / 2;
    if (this.scroller.scrollTo) {
      this.scroller.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    } else {
      this.scroller.scrollLeft = Math.max(0, left);
    }
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-polaris-recovery]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__polaris) return;
      root.__polaris = new Polaris(root);
      instances.push(root.__polaris);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme-Editor
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-polaris-recovery]');
    if (root && root.__polaris) { root.__polaris.destroy(); root.__polaris = null; }
  });
  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target.closest ? event.target.closest('[data-polaris-section]') : null;
    var root = event.target.closest ? event.target.closest('[data-polaris-recovery]') : null;
    if (root && root.__polaris && section) root.__polaris.scrollTo(section);
  });
})();
